export default __webpack_public_path__ + "static/media/ca.cd0a9e7a.mp3";